import GoogleMapsLoader from 'google-maps';

import styles from './styles.json';

export default class BrixMap {
  static init(...parameters) {
    return new BrixMap(...parameters);
  }

  constructor(block) {
    this.block = block;
    this.tabletMode = false;

    // Check if state has changed otherwise do not change map options and position.
    this.isParentTablet = null;

    // Map center point has two states
    this.mapCenterPoint = null;
    this.onReady();
  }

  onReady() {
    this.mapContainer = this.block.querySelector('.map');
    this.initMap();
  }

  initMap() {
    GoogleMapsLoader.KEY = this.mapContainer.dataset.key;
    GoogleMapsLoader.load((google) => this.mapLoaded(google));
  }

  mapLoaded(google) {
    this.google = google;
    const mapWrapper = this.mapContainer;
    const latF = parseFloat(this.mapContainer.dataset.lat);
    const lngF = parseFloat(this.mapContainer.dataset.lng);
    const zoomInt = parseInt(this.mapContainer.dataset.zoom, 10);
    // const pinColor = this.convertHex(this.container.dataset.pincolor, 1);
    // Avoid svg – will not show in IE 11. Use base64 encoded png.
    const markerIcon = {
      url: ' data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAAB8CAYAAADQOhZyAAAABGdBTUEAALGPC/xhBQAACS1JREFUeAHtXGuoFVUUvma+r5lKqWn46qqZPUQjzQeUpuUrsIcEQUZFFEhS0Itb3vyRUFKGlYgmUVgQJZX96KGikC9UKpFMS29eUyszK027er31fXLncJwz+8zsvdY8zuku+Dxn9t7rW99aM2dmz565VlS42QC4zQE2AYeAemA/sAaYDXQH4rQWIL8FWAp8C/wJHAd2AcuB24DzgditMyIsBhqAf4uA4mqAVoC2jQDhFqBYfPbtBCYCsVkVmHcDYULy+9difBdAy+4F0SkgP0ax740Y+6RW8Hyei7FRBxQLbupbD7/W+WSO3+90jE9d/Bmr2iqwmRKO0v6yUE1/+P8t0MCf+HVCDTn3yQIhXrF4mDMpV3sXjh6X6+c61+B+v9UKYpjEAj9xxO2eGMdzgWsh8v2Gh8U8L2TAhegfGzImave0qAN946Zim5dZDQvVEFaQoVChdT3vC66uDlld6+BjcgnlCitIDxOzY/slDn6aGkLjhxUkrN82Pxc+Fx+TrlCusAGclmvaQQcyTQ2h8cMKsh0J8AyvYQdActiB6CsHH5PL16YOm3bONPMvXa7fF9kEzRvLk7FrTL/fqDxe568zFASdAccQZwUVFSsVNGwFh8rlmySbhYLegL/EWEybmzr/kcGf/TiJAL9vHzTw9+8PFGWb56EOgNQeBEGUeEFj5kqDB/kPQyPP0kEBTW08ifUKInNsewJ+ttP4l+Cj8lMJ0szkPgRMBfDaT2PM60AloG2TQPgD4MUyfXLn3a0d3MQ3Eh2vAXsBJk9R/wA7gHnAQCBOaw3ye4CPgSOAV5Sj+P4F8BCg8TMFjb1xLtPJ3k3Voy3Y2qsyNpM1V6C5AlEqENvlKCB4P7RdDwxqwgB88rFGR4BXI2rh44tjwO/A98Au4DuAtw97gJI2LixNAZYAtYB3JXD9rAPHmwBXvVoBJWPc8/OBnwHX5MP8OGteCPBoy6xdDmXLAd7IhSWk1c9Y7wFXA5mxrlCyDEiyEEEFfQsa+EAtVZuJ6L8BQQLTaOPJmDeBiRtnpiuANJKOEvMjaOMjlESMv1deEqMIS3MM77N4hx6rjQc75wppJmoTm8+DJ8ZVkekgri+hYniFo2a+OaBqLEYD4AUptU9eAe/QqshoEJ0s4WJ4O4/rNWOlReGsk5cyj7TUP48iF04gnawNvLgmWupF8Ovnql47l4rwXsFPVi7b1g/NeKkql+RNefBOvMCC1kO4gMvDqqpgtF4Dn9V8DuwDDgEHARpfV+gB9AYmAFcBcVktiAcDPNkWtafQa6qqpJ2z29lA36LRz+3kWPrENTN+5txwhVu8c9WeiXLtYhYgWdShLznIJdkpfl/OZLsBRnsOPX4nyTbXRy4wRrPvIBc5JZr8vs+bZFSiI/+hj9/RZrsRXKGHo0lIhHZyM4aNJtNYzk24rltgD6PF5GTTzin+jAJ2/QbG0LqdeCRI3gY02iRuGvtYEHlMbYxl0mHTvsWvj28Z2xCYxvL3nbRpnVOq8oU/jQ1TklHb+fzEaUqcL8ThO2MydlSdpnHV+bFXKxDenk+Y8HfGNiUatX2tp7k1vpwQEm6DfwuPMIVPxqaGqMkHjTsJf97QVowREpE88L6A5AkaNQQlatM2hu92SO8X/gDHpwkmbgpFDdQisaEsyAAJA3w/AzgfSNuogVokdplGQT6RKFD2lWqpYkF6C0VtEvpruku19GZBAufxFiq5npEVk2q5QFqQ46gEb6GzYtRCTa5WyYLwLtfVfnF1jNFPoulsQU4LxGXxVcgOgnxOcYZ3BuCR4mL05UyXaxNZsJYQcQpwzaeRjpIjhAIuArJifGHGtRjMoYHO0pNiXzJlxPoIdZxgQfhynMRuljgr+04U8h1mQfYISSYL/TXdpwnJ6liQjUKSYfDnw6W07VII4B9eS+wbOvcDbG6Rg8bOk6hQ8qWGIG02bSM8LVwcsXH0j+WJubtHlsInj1Bq8Ouy2T7njp2Hio1z0NiFKRTCC7lIQf9PHhk/5yoQckI0hmQJG2NyLhW0k2za+EZ0znjHq/EkjPcRvXKs8X/hiZQxbRI3jb3JL3evEjEf+rT1k8ew3Q6cWwFTgjbt9eAp+G9BqpXIKWQ9EOd75+TWetJIvauBAuMywBnAprLFxtaCa0hBFHkDOcldLLZt30yTLC7B2ZIVG/8X+B4FeEcstTYgeBwgZ7GYtn283HYDAu1WtNoSRhlfC967AJeHWbyjpu+PQJRYtmOKLkwzuNZZO0jYIfAvBiYB3OMmYx/HLAF+BYK4tNqmgz9nQXusBr1zciPi+8LzFYt/sAnUwpfuegLSdQ1QRLLDGMV4nMcYjfMI/q609kCWeeYbq+Dr4B/gZDkRDW3c6f19eRs3R/0PCvK2MXtDx6oyLgrPX4MMeRubx5RxQZYasw7pWFmGReGTvR4heRu7B6KHlySNk1hWOGqM2UbseKWMCsJFIMmTvbMl64J/j5RJUWaczUjhn/vKoCBrFOqQo+C0+ssSLgrPg4Nz2Sh9uRI8pXqCjTxFt63Vi3DIytUiqo590Cw+kZoKRWKttdeoCUnHTTUlo9U+DkRSkUn5f6CVdBgPp75JJeUah0uNPcMS0ervBKIDgKvYJPxmaSUblSeu9VeNYm1EEnyzIXF7BxE1EtDkqIemKxKvRFNATuu5JqqZkJSrpklbah9TMlSQHdCi8QxIXMxlGSgKV8FyL7yIMxIS8A+M6wDp4S7xXyDMQd19PBgbUyoKZ8+xTc8llXo1hYJwJ9wgER2nL9/Z2AlIDn1bX75OlWkbDnVJLRPwTrZjpqvRJK4an7Z72mX8hFIoBjW2BDYALklG9XF+tkKBaVh/BD0GRE3QZtx+8PIGs+Tsfii2STTq2Cz9wYH1TlmhXJQl1goy5sAbQD4girr3i43jVYWz4pK3G5GBxiyWs+GysReQSbG9H9aX+QmY7Z5qBYdtjkWphV+lbcBSGM+3CWz/jCPT9yoaRX8AJGE/j/z+NP/sRCPfSBzvRyzKboxrH4mxxAd1hn5eQvOPBP/3BvSPLPE8reSPxmgm7S+Etz3Piq1MBj9rKMh2tGdisTjpOvNh0jpfUfinatckLSRL8XpBzBHA+6lUZ0lcWlq8x6KbIYBrKc2GCvAtH+u3i7Ur9x+JUBsgJN10lwAAAABJRU5ErkJggg==',
      scaledSize: new google.maps.Size(34, 62), // Scaled size of marker image
      anchor: new google.maps.Point(17, 31), // Centers anchor point
    };

    const options = {
      zoom: zoomInt,
      center: { lat: latF, lng: lngF },
      mapTypeControl: false,
      scrollwheel: false,
      streetViewControl: false,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.ROADMAP,
        mapTypeIds: ['roadmap', 'terrain'],
      },
      styles,
    };
    this.map = new google.maps.Map(mapWrapper, options);

    this.marker = new google.maps.Marker({
      position: { lat: latF, lng: lngF },
      map: this.map,
      icon: markerIcon,
      optimized: false,
    });
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-map', BrixMap.init);
}
